import get from 'lodash/get';
import unset from 'lodash/unset';
import { CheckBoxStatus } from '@rome/response/common/leaf/value/CheckBoxStatus';
import { WidgetTypeV4 } from '@rome/response/page/v4/WidgetTypeV4';
import { NotifPrefsAccordionActions } from 'actions/notifPrefsAccordionActions';
import { CheckboxSelectionStatus } from 'widgets/RichAccordian/RichAccordian';
import { PAGE_DATA_ACTIONS } from 'actions/pageActionsV4';
import { pageTypes } from 'constants/pageTypes';
export const getSelectionStatus = (items, itemIndex) => {
    let totalCount = 0;
    let selectedCount = 0;
    items.forEach(item => {
        let { parentIndex } = item;
        if (parentIndex !== itemIndex) {
            return;
        }
        totalCount++;
        if (get(item, 'value.checkbox.value.status') === CheckBoxStatus.SELECTED) {
            selectedCount++;
        }
    });
    if (selectedCount === totalCount) {
        return CheckboxSelectionStatus.FULLY;
    }
    return selectedCount === 0 ? CheckboxSelectionStatus.DESELECTED : CheckboxSelectionStatus.PARTIALLY;
};
export const flattenItems = (items, parentIndex = -1, counter = { val: 0 }) => {
    if (!Array.isArray(items) || items.length === 0) {
        return [];
    }
    return items.reduce((flatItems, item) => {
        const flatItem = Object.assign(Object.assign({}, item), { value: Object.assign({}, item.value), index: counter.val++, parentIndex, hasChildren: Boolean(get(item, 'value.items', []).length) });
        flatItems.push(flatItem);
        const items = get(flatItem, 'value.items');
        if (Array.isArray(items) && items.length) {
            flatItems = [...flatItems, ...flattenItems(items, counter.val - 1, counter)];
            //@ts-ignore
            delete flatItem.value.items;
        }
        return flatItems;
    }, []);
};
const setItems = (state, action) => {
    if (action['pageType'] !== pageTypes.NotificationPreferencesPage) {
        return state;
    }
    let slots = get(action, 'data.slots');
    const slot = slots.find(slot => slot['widget'] && get(slot, 'widget.type') === WidgetTypeV4.CHECKABLE_RICH_NAV);
    let items = get(slot, 'widget.data.renderableComponents');
    // removing renderableComponents from widget since we no longer need it
    unset(slot, 'widget.data.renderableComponents');
    return Object.assign(Object.assign({}, state), { items: flattenItems(items) });
};
const getUpdatedItem = (item, status, showWarning) => {
    return Object.assign(Object.assign({}, item), { value: Object.assign(Object.assign({}, item.value), { showWarning: showWarning !== null ? showWarning : get(item, 'value.showWarning'), checkbox: status !== null
                ? Object.assign(Object.assign({}, get(item, 'value.checkbox')), { value: Object.assign(Object.assign({}, get(item, 'value.checkbox.value')), { status }) }) : get(item, 'value.checkbox') }) });
};
const toggleItemChecked = (state, action) => {
    const items = [...state.items];
    // check if the clicked item is parent or child
    if (items[action.index].hasChildren) {
        // if parent then update the checked status for the clicked item
        items[action.index] = getUpdatedItem(items[action.index], action.checked ? CheckBoxStatus.SELECTED : CheckBoxStatus.UNSELECTED, null);
        /**
         * clicking a parent should also mark all its children as selected or unselected
         * based on parent's checked status
         */
        items.forEach(({ parentIndex, value }, index) => {
            if (parentIndex !== action.index) {
                return;
            }
            let status = null;
            // do not update status for disabled item
            if (!get(value, 'disabled')) {
                status = action.checked ? CheckBoxStatus.SELECTED : CheckBoxStatus.UNSELECTED;
            }
            items[index] = getUpdatedItem(items[index], status, false);
        });
    }
    else {
        // if child then update checked status and showWarning for clicked item
        const item = getUpdatedItem(items[action.index], action.checked ? CheckBoxStatus.SELECTED : CheckBoxStatus.UNSELECTED, !action.checked);
        items[action.index] = item;
        // hide warnings for all other sibling items
        if (!action.checked) {
            items.forEach(({ parentIndex }, index) => {
                if (parentIndex !== item.parentIndex || index === action.index) {
                    return;
                }
                items[index] = getUpdatedItem(items[index], null, false);
            });
        }
        // update the checked status for parent of the clicked item based on the selection status
        const selectionStatus = getSelectionStatus(items, item.parentIndex);
        let status;
        switch (selectionStatus) {
            case CheckboxSelectionStatus.FULLY:
                status = CheckBoxStatus.SELECTED;
                break;
            case CheckboxSelectionStatus.PARTIALLY:
                status = CheckBoxStatus.PARTIAL;
                break;
            case CheckboxSelectionStatus.DESELECTED:
                status = CheckBoxStatus.UNSELECTED;
                break;
            default:
                status = null;
        }
        items[item.parentIndex] = getUpdatedItem(items[item.parentIndex], status, null);
    }
    return Object.assign(Object.assign({}, state), { items });
};
const toggleItemOpened = (state, action) => {
    const items = [...state.items];
    items[action.index] = Object.assign(Object.assign({}, items[action.index]), { value: Object.assign(Object.assign({}, items[action.index].value), { opened: !get(items[action.index], 'value.opened') }) });
    return Object.assign(Object.assign({}, state), { items });
};
const defaultState = {
    items: []
};
const notifPrefsAccordion = (state = defaultState, action) => {
    switch (action.type) {
        case PAGE_DATA_ACTIONS.SUCCESS:
            return setItems(state, action);
        case NotifPrefsAccordionActions.TOGGLE_CHECKED:
            return toggleItemChecked(state, action);
        case NotifPrefsAccordionActions.TOGGLE_OPENED:
            return toggleItemOpened(state, action);
        default:
            return state;
    }
};
export default notifPrefsAccordion;
